import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail"]

  reveal(event) {
    event.preventDefault()
    const documentId = String(event.params.documentId)
    const detail = this.detailTargets.find(d => d.dataset.documentId === documentId)
    if (!detail) return

    detail.open = true
    detail.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }
}
